import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import {
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/tipoAreia/actions';

import Form from './form';

function PitStopTipoAreia() {
  const redux = useSelector((state) => state.tipoAreia);

  const status = useMemo(
    () => [
      { label: 'S', value: t('s.geral.opcoes.sim') },
      { label: 'N', value: t('s.geral.opcoes.nao') },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'descricaotipoareia',
        label: t('s.cadastro.modeloveiculo.descricao'),
        filter: { type: 'text' },
      },
      {
        id: 'pesounitariokgtipoareia',
        label: t('s.cadastro.pitstop.sacosatendimentoareia'),
        filter: { type: 'number' },
      },
      {
        id: 'silotipoareia',
        label: t('s.cadastro.pitstop.silotipoareia'),
        formatted: (value) => status.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: status },
      },
    ],
    []
  );

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findData}
      remove={deleteData}
      form={Form}
      keys="idtipoareia"
      detach="descricaotipoareia"
    />
  );
}

export default PitStopTipoAreia;
